import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import './directives/index'

// import './plugins/element.js'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';

// Vue.use(ElementUI,{ size: 'mini', zIndex: 3000 });

// 常用方法挂在到VUE原型上
import base from '@/utils/base'
Object.keys(base).forEach(item => {
    Vue.prototype[item] = base[item]
})

// 注册全局组件
const files = require.context('@/components',true,/index\.vue$/);
files.keys().forEach(item=>{
    const fileItem = files(item).default;
    // 如果组件内定义name 则需要全局引用的
    if(fileItem.name){
        Vue.component(fileItem.name,fileItem);
    }
});
Vue.directive('throttle', { 
    inserted(el, binding) { 
        el.addEventListener('click', () => { 
            el.style.pointerEvents = 'none'; 
            if (!el.disabled) { 
                setTimeout(() => { 
                    el.style.pointerEvents = 'auto'; 
                }, binding.value || 2000); 
            } 
        }); 
    } 
});

// eslint-disable-next-line no-unused-vars
// import directives from '@/directives/index'
import mixins from '@/mixins/index'
import router from '@/router/index'
import store from '@/store/index'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import VideoPlayer from 'vue-video-player'
require('vue-video-player/node_modules/video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

Vue.prototype.$video = Video
Vue.mixin(mixins)

new Vue({
    router,
    store,
    mounted() {},
    render: h => h(App)
}).$mount('#app')
